document.addEventListener('DOMContentLoaded', () => {
  // Menú móvil / tablet estrecha (drawer lateral)
  const mobileDrawer = document.querySelector('[data-healtto-mobile-drawer]');
  const menuToggle = document.querySelector('[data-healtto-mobile-nav-toggle]');
  if (mobileDrawer && menuToggle) {
    const closeTriggers = mobileDrawer.querySelectorAll('[data-healtto-mobile-drawer-close]');
    const drawerLinks = mobileDrawer.querySelectorAll('[data-healtto-mobile-drawer-link]');
    let focusBeforeOpen = null;

    function isDesktopNav() {
      return window.matchMedia('(min-width: 1024px)').matches;
    }

    function openDrawer() {
      focusBeforeOpen = document.activeElement;
      mobileDrawer.hidden = false;
      mobileDrawer.setAttribute('aria-hidden', 'false');
      menuToggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('healtto-nav-drawer-open');
      const closeBtn = mobileDrawer.querySelector('.healtto-header__mobile-drawer-close');
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      mobileDrawer.hidden = true;
      mobileDrawer.setAttribute('aria-hidden', 'true');
      menuToggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('healtto-nav-drawer-open');
      if (focusBeforeOpen && typeof focusBeforeOpen.focus === 'function') {
        focusBeforeOpen.focus();
      } else {
        menuToggle.focus();
      }
      focusBeforeOpen = null;
    }

    menuToggle.addEventListener('click', () => {
      if (mobileDrawer.hidden) openDrawer();
      else closeDrawer();
    });

    closeTriggers.forEach((el) => {
      el.addEventListener('click', () => closeDrawer());
    });

    drawerLinks.forEach((link) => {
      link.addEventListener('click', () => closeDrawer());
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !mobileDrawer.hidden) closeDrawer();
    });

    window.addEventListener('resize', () => {
      if (isDesktopNav()) closeDrawer();
    });
  }

  const hero = document.querySelector('[data-healtto-hero-slider]');
  if (hero) {
    const slides = hero.querySelectorAll('[data-hero-slide]');
    const dots = hero.querySelectorAll('[data-hero-dot]');
    if (slides.length && dots.length) {
      let index = 0;
      const setActive = (i) => {
        slides.forEach((slide, idx) => {
          slide.hidden = idx !== i;
        });
        dots.forEach((dot, idx) => {
          dot.classList.toggle('healtto-hero__dot--active', idx === i);
        });
      };
      setActive(index);
      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          index = i;
          setActive(index);
        });
      });
      setInterval(() => {
        index = (index + 1) % slides.length;
        setActive(index);
      }, 7500);
    }
  }

  // Carruseles de productos (Los más buscados / Lo más nuevo)
  document.querySelectorAll('.healtto-products-carousel').forEach((carousel) => {
    const track = carousel.querySelector('[data-healtto-products-carousel]');
    const prevBtn = carousel.querySelector('[data-carousel-prev]');
    const nextBtn = carousel.querySelector('[data-carousel-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function getScrollStep() {
      const card = track.querySelector('.healtto-product-card');
      if (!card) return 320;
      const gap = 28;
      return card.offsetWidth + gap;
    }

    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
    });
  });

  // Galería de producto: miniaturas + zoom (hover) y lightbox (clic / teclado)
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mainImg = gallery.querySelector('.healtto-product-gallery__img');
    const thumbs = gallery.querySelectorAll('[data-product-gallery-thumb]');

    if (mainImg && thumbs.length) {
      thumbs.forEach((btn) => {
        btn.addEventListener('click', () => {
          const src = btn.getAttribute('data-src');
          const srcset = btn.getAttribute('data-srcset');
          const alt = btn.getAttribute('data-alt') || '';
          const zoomSrc = btn.getAttribute('data-zoom-src');
          if (src) mainImg.src = src;
          if (srcset) {
            mainImg.srcset = srcset;
          } else {
            mainImg.removeAttribute('srcset');
          }
          mainImg.alt = alt;
          if (zoomSrc) mainImg.setAttribute('data-zoom-src', zoomSrc);
          else mainImg.removeAttribute('data-zoom-src');
          thumbs.forEach((t) => t.classList.remove('is-active'));
          btn.classList.add('is-active');
        });
      });
    }

    const viewport = gallery.querySelector('[data-product-zoom-viewport]');
    const lightbox = gallery.querySelector('[data-product-zoom-lightbox]');
    const lightboxImg = gallery.querySelector('[data-product-zoom-lightbox-img]');
    const overlay = gallery.querySelector('[data-product-zoom-lightbox-overlay]');

    if (!viewport || !mainImg || !lightbox || !lightboxImg || !overlay) return;

    function setZoomOrigin(clientX, clientY) {
      const rect = viewport.getBoundingClientRect();
      if (rect.width < 1 || rect.height < 1) return;
      const x = ((clientX - rect.left) / rect.width) * 100;
      const y = ((clientY - rect.top) / rect.height) * 100;
      viewport.style.setProperty('--zoom-x', `${Math.min(100, Math.max(0, x))}%`);
      viewport.style.setProperty('--zoom-y', `${Math.min(100, Math.max(0, y))}%`);
    }

    viewport.addEventListener('mousemove', (e) => {
      setZoomOrigin(e.clientX, e.clientY);
    });

    function openLightbox() {
      const hi =
        mainImg.getAttribute('data-zoom-src') ||
        mainImg.currentSrc ||
        mainImg.src;
      lightboxImg.src = hi;
      lightboxImg.alt = mainImg.alt || '';
      if (typeof lightbox.showModal === 'function') {
        lightbox.showModal();
      }
    }

    function closeLightbox() {
      if (lightbox.open) lightbox.close();
    }

    viewport.addEventListener('click', () => {
      openLightbox();
    });

    viewport.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openLightbox();
      }
    });

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeLightbox();
    });

    gallery.querySelectorAll('[data-product-zoom-lightbox-close]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        closeLightbox();
      });
    });

    lightbox.addEventListener('close', () => {
      lightboxImg.removeAttribute('src');
    });
  });

  // Cantidad +/- en ficha de producto
  document.querySelectorAll('[data-qty-group]').forEach((group) => {
    const input = group.querySelector('[data-qty-input]');
    const minus = group.querySelector('[data-qty-minus]');
    const plus = group.querySelector('[data-qty-plus]');
    if (!input || !minus || !plus) return;

    minus.addEventListener('click', () => {
      const v = Math.max(1, parseInt(input.value, 10) - 1 || 1);
      input.value = String(v);
    });
    plus.addEventListener('click', () => {
      const v = Math.max(1, parseInt(input.value, 10) + 1 || 2);
      input.value = String(v);
    });
  });

  // Búsqueda predictiva (solo productos; blog excluido por API)
  const PREDICTIVE_MIN_CHARS = 2;
  const PREDICTIVE_LIMIT = 8;
  const PREDICTIVE_DEBOUNCE_MS = 250;

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function suggestJsonUrl() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    const base =
      typeof root === 'string' && root.length ? root : '/';
    const normalized = base.endsWith('/') ? base : `${base}/`;
    return new URL('search/suggest.json', `${window.location.origin}${normalized}`);
  }

  function productImageUrl(product) {
    const img = product.featured_image;
    if (!img) return '';
    if (typeof img === 'string') return img;
    if (img && typeof img === 'object' && img.url) return img.url;
    return '';
  }

  function productPriceDisplay(product) {
    const p = product.price;
    if (p == null || p === '') return '';
    if (typeof p === 'string') return p;
    const n = Number(p);
    if (Number.isNaN(n)) return String(p);
    const currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(n);
    } catch {
      return String(p);
    }
  }

  function debounce(fn, ms) {
    let t;
    return function debounced(...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), ms);
    };
  }

  document.querySelectorAll('[data-healtto-predictive-search]').forEach((wrap) => {
    const input = wrap.querySelector('[data-healtto-search-input]');
    const panel = wrap.querySelector('[data-healtto-search-panel]');
    if (!input || !panel) return;

    let abort = null;
    let docClickOutsideAttached = false;

    function onDocumentClickOutside(e) {
      if (panel.hidden) return;
      if (!wrap.contains(e.target)) closePanel();
    }

    function closePanel() {
      if (docClickOutsideAttached) {
        document.removeEventListener('click', onDocumentClickOutside, true);
        docClickOutsideAttached = false;
      }
      panel.hidden = true;
      panel.classList.remove('is-open');
      panel.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    }

    function openPanel() {
      panel.hidden = false;
      panel.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
      if (!docClickOutsideAttached) {
        docClickOutsideAttached = true;
        document.addEventListener('click', onDocumentClickOutside, true);
      }
    }

    function renderHits(products) {
      if (!products.length) {
        panel.innerHTML =
          '<div class="healtto-header__search-status">Sin resultados para tu búsqueda.</div>';
        openPanel();
        return;
      }
      const html = products
        .map((product) => {
          const title = escapeHtml(product.title || '');
          const href = product.url || '#';
          const img = productImageUrl(product);
          const price = productPriceDisplay(product);
          const imgHtml = img
            ? `<img class="healtto-header__search-hit-img" src="${escapeHtml(img)}" alt="" width="44" height="44" loading="lazy">`
            : '<span class="healtto-header__search-hit-img" aria-hidden="true"></span>';
          const priceHtml = price
            ? `<div class="healtto-header__search-hit-price">${escapeHtml(price)}</div>`
            : '';
          return `<a class="healtto-header__search-hit" href="${escapeHtml(href)}" role="option">${imgHtml}<div class="healtto-header__search-hit-body"><div class="healtto-header__search-hit-title">${title}</div>${priceHtml}</div></a>`;
        })
        .join('');
      panel.innerHTML = html;
      openPanel();
    }

    function renderStatus(message, isError) {
      const cls = isError
        ? 'healtto-header__search-status healtto-header__search-status--error'
        : 'healtto-header__search-status';
      panel.innerHTML = `<div class="${cls}">${escapeHtml(message)}</div>`;
      openPanel();
    }

    const runSearch = debounce(async () => {
      const q = input.value.trim();
      if (q.length < PREDICTIVE_MIN_CHARS) {
        closePanel();
        return;
      }

      if (abort) abort.abort();
      abort = new AbortController();

      const url = suggestJsonUrl();
      const params = new URLSearchParams();
      params.set('q', q);
      params.set('resources[type]', 'product');
      params.set('resources[limit]', String(PREDICTIVE_LIMIT));
      params.set('resources[options][unavailable_products]', 'last');
      params.set(
        'resources[options][fields]',
        'title,product_type,variants.title,vendor,body'
      );

      try {
        const res = await fetch(`${url}?${params.toString()}`, {
          signal: abort.signal,
          headers: { Accept: 'application/json' },
        });
        if (!res.ok) {
          renderStatus('No se pudieron cargar los resultados.', true);
          return;
        }
        const data = await res.json();
        const products =
          (data.resources &&
            data.resources.results &&
            data.resources.results.products) ||
          [];
        renderHits(products);
      } catch (e) {
        if (e.name === 'AbortError') return;
        renderStatus('Error de conexión. Intenta de nuevo.', true);
      }
    }, PREDICTIVE_DEBOUNCE_MS);

    input.addEventListener('input', () => {
      runSearch();
    });

    input.addEventListener('focus', () => {
      if (input.value.trim().length >= PREDICTIVE_MIN_CHARS) runSearch();
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closePanel();
        input.blur();
      }
    });

    const form = wrap.querySelector('form');
    if (form) {
      form.addEventListener('submit', () => closePanel());
    }
  });
});

